/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { N40A, N50A, N90 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { smallTextTypography } from '../../utils/styled/text';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HeaderLink = styled.div`
	margin-left: ${token('space.300', '24px')};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FooterLink = styled.div`
	font-size: ${token('font.body.small')};
	margin-left: ${token('space.150', '12px')};
	margin-top: ${token('space.200', '16px')};
	display: flex;
	color: ${token('color.text.subtlest', N90)};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const WorkListInfoText = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	${smallTextTypography};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const WorkListItems = styled.div`
	border-radius: ${token('border.radius.100', '3px')};
	background-color: ${token('elevation.surface.raised', 'transparent')};
	box-shadow: ${token('elevation.shadow.raised', `0 1px 1px ${N50A}, 0 0 1px 1px ${N40A}`)};
	padding: ${token('space.200', '16px')} ${token('space.100', '8px')};

	/* Use less margin if info text is present  */
	${WorkListInfoText} + & {
		margin-top: ${token('space.200', '16px')};
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NoWorkListImage = styled.img`
	height: ${8 * 18}px;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NoWorkListTextColumn = styled.div`
	margin-left: ${token('space.400', '32px')};
	min-width: 180px;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NoWorkListTitle = styled.h3`
	margin-bottom: ${token('space.200', '16px')};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NoWorkListDescription = styled.p``;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SkeletonWrapper = styled.div`
	& + & {
		margin: ${token('space.050', '4px')} 0 0 0;
	}
`;
